export interface Role {
  id: string
  nameKey: string
}

export const ROLES: Role[] = [
  { id: 'ceo_founder', nameKey: 'role.ceoFounder' },
  { id: 'c_level', nameKey: 'role.cLevel' },
  { id: 'director_manager', nameKey: 'role.directorManager' },
  { id: 'investor', nameKey: 'role.investor' },
  { id: 'policy_maker', nameKey: 'role.policyMaker' },
  { id: 'researcher_academic', nameKey: 'role.researcherAcademic' },
  { id: 'other', nameKey: 'role.other' },
]
